import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import KEYS from '@/values/keys';
import Moment from 'moment';
import { BUILDER_DAY_OPTIONS, BUILDER_RULES, BUILDER_EVENT_TYPES } from '@/courses/values/courses.values';

@Component({
  name: 'ed-subject-day-options'
})
export default class EdSubjectDayOptionsComponent extends Vue {

  @Prop() readonly params: any;

  public saving: boolean = false;
  public radioModel: string = BUILDER_DAY_OPTIONS.IGNORED;
  public prevOption: string = BUILDER_DAY_OPTIONS.IGNORED;
  public funDates: any = [];

  get radioOptions() {
    return [{
      label: this.$t('courses.subjectBuilder.standardDay'),
      value: BUILDER_DAY_OPTIONS.IGNORED
    }
    /*,{
      label: this.$t('courses.subjectBuilder.dayOff'),
      value: BUILDER_DAY_OPTIONS.OBSERVED
    }*/,{
      label: this.$t('courses.subjectBuilder.fun'),
      value: BUILDER_DAY_OPTIONS.FUN
    }];
  }

  get specialDays () {
    // filtering to handle db bringing events that don't exist anymore as status ignored when is official false
    return this.params.specialDays.filter(el => !(el.status === BUILDER_DAY_OPTIONS.IGNORED && !el.official)) || [];
  }

  get dateTitle() {
    let lan = this.$i18n.locale;
    let format = lan === 'es' ? 'dddd, D MMMM' : 'dddd, Do MMM';
    let date = Moment(this.params.date).locale(lan).format(format).toString()
    return date.charAt(0).toUpperCase() + date.slice(1)
  }

  get date () {
    return Moment(this.params.date).format('YYYY-MM-DD').toString();
  }

  /* Methods */
  closeModal() {
    this.$EdModal.closeModal();
  }

  save() {
    this.saving = true;
    this.funDates = [];
    let specialDays = this.specialDays;
    let rule;
    let dayOff = this.specialDays.find(el => el.startDate == this.date && el.status !== BUILDER_DAY_OPTIONS.FUN);
    let dates = [];
    if(dayOff && dayOff.endDate) {
      let currentDate = Moment(dayOff.startDate);
      while (currentDate <= Moment(dayOff.endDate)) {
        dates.push(Moment(currentDate).format('YYYY-MM-DD'));
        currentDate = Moment(currentDate).add(1, 'days');
      }
    } else dates = [this.date]


    if(this.specialDays.find(el => el.startDate == this.date && el.status == BUILDER_DAY_OPTIONS.FUN) && this.radioModel !== BUILDER_DAY_OPTIONS.FUN) {
      this.params.lessons.find(el => el.rootType === BUILDER_DAY_OPTIONS.FUN && el.schoolDate == this.date) ? rule = BUILDER_RULES.REMOVE_FUN_LESSON : null;

    } else  {
      let funLessonsLen = this.specialDays.filter(el => el.status == BUILDER_DAY_OPTIONS.FUN).length;
      dates.forEach(date => {
        if ((
          (this.specialDays.find(el => el.startDate == date && el.status !== BUILDER_DAY_OPTIONS.FUN) && this.radioModel == BUILDER_DAY_OPTIONS.FUN)
          || (!this.specialDays.find(el => el.startDate == date) && this.radioModel == BUILDER_DAY_OPTIONS.FUN))
        ) {
          if(funLessonsLen < this.params.existFunLessons) {
            rule = BUILDER_RULES.ADD_FUN_LESSON;
            this.funDates.push(date);
            funLessonsLen++;
          }
        }
      })

    }

    rule ? rule = { type: rule, funDate: this.date, funDates: this.funDates } : rule = null;
    let addSpecialDay;
    dates.forEach(date => {
      if(this.specialDays.find(el => el.startDate == date && el.status !== BUILDER_DAY_OPTIONS.NOTIFIED)) {
        specialDays = this.specialDays.map(el => {
          if(el.startDate == date && !el.official && el.status !== BUILDER_DAY_OPTIONS.NOTIFIED) {
            return {
              ...el,
              endDate: date,
              name: this.radioOptions.find(el => el.value == this.radioModel).label,
              status: this.radioModel
            }
        } else if(el.startDate == this.date && el.official) {
          addSpecialDay = {
            endDate: this.date,
            holidayPlanId: null,
            name: this.radioOptions.find(el => el.value == this.radioModel).label,
            official: false,
            startDate: this.date,
            status: this.radioModel
          }
          return {
            ...el,
            status: 'IGNORED'
          }
        }
        else return el
        });

      specialDays = addSpecialDay ? specialDays.concat(addSpecialDay) : specialDays;
        // Remove repeated items -> for old data
        specialDays = specialDays.reduce(function (acc, curr) {
          if (!acc.find(el => el.startDate === curr.startDate && el.status === curr.status && el.official == false))
              acc.push(curr);
          return acc;
        }, []);

      } else if(this.radioModel !== BUILDER_DAY_OPTIONS.IGNORED) {
        specialDays = specialDays.concat({
          endDate: date,
          holidayPlanId: null,
          name: this.radioOptions.find(el => el.value == this.radioModel).label,
          official: false,
          startDate: date,
          status: this.radioModel
        })
      }
    })

    specialDays = specialDays.filter(el => !(el.status === BUILDER_DAY_OPTIONS.IGNORED && !el.official));
    this.closeModal();
    setTimeout(() => {
      this.params.setSpecialDays(specialDays, rule, this.radioModel, this.prevOption, this.date);
      this.saving = false;
    }, 200)
  }

  setRadioInit() {
    if (this.specialDays.length) {
      const data = this.specialDays.find((el) => {
        const isOfficial = el.official && el.status !== BUILDER_DAY_OPTIONS.OBSERVED;

        return el.startDate == this.date && !isOfficial && el.status !== BUILDER_DAY_OPTIONS.NOTIFIED
      });

      this.radioModel = this.prevOption = data ? data.status : BUILDER_DAY_OPTIONS.IGNORED;
      if(this.specialDays.find(el => el.startDate == this.date && el.status == BUILDER_DAY_OPTIONS.OBSERVED)) {
        this.radioModel = BUILDER_DAY_OPTIONS.OBSERVED;
      }
    }
  }

  mounted() {
    this.setRadioInit();
  }
}